// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BulbTwoToneSvg from "@fishx/icons-svg/es/asn/BulbTwoTone";
import FishxIcon from '../components/FishxIcon';

var BulbTwoTone = function BulbTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BulbTwoToneSvg
  }));
};

BulbTwoTone.displayName = 'BulbTwoTone';
export default React.forwardRef(BulbTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BulbTwoTone.js
// module id = 2138
// module chunks = 0